module.exports = __webpack_public_path__ + "files/8a0b9aa58d323f8f9b8232c8713a1bb1.png";


/*****************
 ** WEBPACK FOOTER
 ** ./images/icons/image.png
 ** module id = 814
 ** module chunks = 0
 **/